import type { ReactNode } from 'react';
import { ErrorBoundary } from '../components/errors/errorBoundary';

export const BasePage = ({ children }: { children: ReactNode }) => {
  return (
    <ErrorBoundary>
      <div className="py-3">{children}</div>
    </ErrorBoundary>
  );
};
